module.exports = __webpack_public_path__ + "static/media/motorcyk-electric-motorcycle.53302547.jpg";